import { NavLink, Outlet, Navigate, useLocation } from "react-router-dom";

const tabs = [
    { label: "Alerts", path: "/fraud-safety/alerts" },
    { label: "Cases", path: "/fraud-safety/cases" },
    { label: "Overview", path: "/fraud-safety/overview" },
];

export const FraudSafetyLayout = () => {
    const location = useLocation();

    // Redirect index to alerts
    if (location.pathname === "/fraud-safety" || location.pathname === "/fraud-safety/") {
        return <Navigate to="/fraud-safety/alerts" replace />;
    }

    // Hide sub-nav on detail pages
    const isDetailPage = /^\/fraud-safety\/(alerts|cases)\/[^/]+/.test(location.pathname);

    return (
        <div className="space-y-6">
            {!isDetailPage && (
                <div>
                    <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">Fraud & Safety</h1>
                    <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                        Monitor fraud alerts, investigate cases, and manage detection rules.
                    </p>
                    <div className="mt-4 flex gap-1 border-b border-slate-200 dark:border-slate-800">
                        {tabs.map((tab) => (
                            <NavLink
                                key={tab.path}
                                to={tab.path}
                                className={({ isActive }) =>
                                    `relative px-4 py-2.5 text-sm font-medium transition-colors ${isActive
                                        ? "text-primary-600 dark:text-primary-400"
                                        : "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300"
                                    }`
                                }
                            >
                                {({ isActive }) => (
                                    <>
                                        {tab.label}
                                        {isActive && (
                                            <span className="absolute bottom-0 left-0 right-0 h-0.5 rounded-full bg-primary-600 dark:bg-primary-400" />
                                        )}
                                    </>
                                )}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
            <Outlet />
        </div>
    );
};
